import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Event from '../../../event';
import styles from './style.css';
import { getQuery, getUuid, setQuery } from '../../utils';

class Iframe extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.duration = props.content.duration;
        this.currentTime = 0;
        this.uuid = getUuid('frondAd');

        this.state = {
            show: false,
        };
    }

    show() {
        this.setState({ show: true });
    }

    hide() {
        this.setState({ show: false });
        clearInterval(this.timer);
    }

    play() {
        this.timer = setInterval(() => {
            this.currentTime += 0.1;
            this.trigger('timeupdate');

            if (this.currentTime >= this.duration) {
                clearInterval(this.timer);
                this.trigger('ended');
            }
        }, 100);

        return Promise.resolve();
    }

    pause() {
        clearInterval(this.timer);

        return Promise.resolve();
    }

    setVolume(volume) {
        // do nothing
    }

    getVolume() {
        // do nothing
    }

    setMuted(muted) {
        // do nothing
    }

    getDom() {
        return this;
    }

    handleMessage = (event) => {
        if (event.data && event.data.type === 'noAd' && getQuery(event.data.url, 'parentId') === this.uuid) {
            this.pause();
            this.currentTime = this.currentTime >= this.duration - 0.1 ? this.currentTime : this.duration - 0.1;
            this.play();
        }
    };

    componentDidMount() {
        // 使用定时器处理子组件componentDidMount早于父组件componentDidMount导致trigger早于on的问题
        setTimeout(() => {
            this.trigger('canplay');
        }, 0);

        window.addEventListener('message', this.handleMessage);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
        window.removeEventListener('message', this.handleMessage);
    }

    render() {
        const { content } = this.props;
        const { url, width, height, playerWidth, playerHeight } = content;
        const { show } = this.state;
        const scale =
            width > playerWidth || height > playerHeight ? Math.min(playerWidth / width, playerHeight / height) : 0;

        return (
            <div className={styles.adIframe} style={{ display: show ? 'block' : 'none' }}>
                <div className={styles.adIframeContent} style={{ width, height }}>
                    <iframe
                        src={setQuery({ url, list: [{ key: 'parentId', value: this.uuid }] })}
                        scrolling="no"
                        frameBorder="no"
                        style={{ width, height, ...(scale > 0 ? { transform: `scale(${scale})` } : {}) }}
                    />
                </div>
            </div>
        );
    }
}

Event.mixTo(Iframe);
export default Iframe;
